<template>
    <div class="contenido">
                
    </div>
</template>

<script>
export default {
    name: "CambioContrasea",
    components: {},

    props: [
        
    ],
    data() {
        return {
        }
    },
    async created() {

    },
    methods: {
        
    
       
    }
};
</script>

<style>

.contenido{
    height: 753px;
    background-color: var(--blue-violet);
    width: 100%;

}
</style>